import { Components, customHooks } from "@thisgorilla/primate-ds";
import { useRef } from "react";
import styled, { useTheme } from "styled-components";

import { useAppSelector } from "../../../redux";
import {
  MOUSE_ENTER_UPDATION_DELAY,
  MOUSE_LEAVE_UPDATION_DELAY,
} from "../../../utils";
import { Popup } from "../Popup";
import { FlexRow } from "../Styles";
import { UserInfoProps } from "./UserInfo";
import AnonymousUserToolTip from "../AnonymousUserToolTip";

const UserInfo = (user: UserInfoProps.IProps) => {
  const { Color, typography } = useTheme();
  const { id: meId, anonymous_persona } = useAppSelector((state) => state.me);
  const {
    id,
    profile_picture,
    name,
    headline,
    avatarSize = "XSmall-28",
    showUserInfoOnHover = true,
    onClick = () => {},
    activeDuration,
    showPostedDate = false,
  } = user;
  const ref = useRef<HTMLDivElement>(null);
  const { isHovered } = customHooks.useMouseOver({
    ref,
    mouseLeaveDelay: MOUSE_LEAVE_UPDATION_DELAY,
    mouseEnterDelay: MOUSE_ENTER_UPDATION_DELAY,
  });

  const isAnonymousUser = name === anonymous_persona;

  return (
    <InfoContainer ref={ref} onClick={onClick}>
      <Components.Avatar
        disabled={false}
        size={avatarSize}
        src={profile_picture}
        type="Circle"
      />
      <NameContainer className="user-info-name-container">
        <FlexRow>
          <Components.Text
            text={name}
            maxLineLength={1}
            style={{ tokenStyle: { ...typography.Heading.XXS } }}
            lineHeight="line-height-50"
            fontWeight="font-weight-semibold"
          />
          {isAnonymousUser && (
            <Components.Tooltip
              type="component"
              label={<AnonymousUserToolTip />}
              showTriangle={false}
            >
              <Components.Icon
                type="Info"
                size="16px"
                color={Color.icon["icon-tertiary"].value}
              />
            </Components.Tooltip>
          )}
        </FlexRow>

        <Components.Text
          text={headline}
          maxLineLength={1}
          style={{ tokenStyle: typography.Body.S }}
          color={Color.text["text-secondary"].value}
        />
        {showPostedDate && (
          <PostedDateAndIcon $gapInPx={2}>
            <Components.Text
              text={`${activeDuration} •`}
              style={{ tokenStyle: typography.Body.S }}
            />
            <Components.Icon type="Globe" size="16px" />
          </PostedDateAndIcon>
        )}
        {!isAnonymousUser &&
          showUserInfoOnHover &&
          isHovered &&
          meId !== id && <Popup parentRef={ref} type="user" id={id} />}
      </NameContainer>
    </InfoContainer>
  );
};

export default UserInfo;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: default;
  position: relative;
`;
const PostedDateAndIcon = styled(FlexRow)`
  align-items: center;
`;
